import React, { FC } from 'react';

import { styled } from '@mui/material/styles';

import AnimatedSkeleton from '~/components/AnimatedSkeleton';
import AnimatedSkeletonMultiline from '~/components/AnimatedSkeletonMultiline';
import IKImage from '~/components/IKImage/IKImage';
import { BodyText } from '~/components/UI/Texts';
import { SKELETON_TEXT_HEIGHT_TINY_PX, SMALL_MARGIN_PX, TINY_MARGIN_PX } from '~/theme';

const LOGO_SRCSET = [
  {
    width: 224,
  },
];

const sustainableGoalImg = '/page-images/sustainableGoal.png';

interface SustainableGoalProps {
  description?: string | null;
  logo?: string | null;
  loading?: boolean;
}

const SustainableGoal: FC<SustainableGoalProps> = ({ description, logo, loading = false }) => {
  if (loading) {
    return (
      <Wrapper>
        <LoadingLogo xs="178px" />
        <InfoWrapper>
          <LoadingImage xs="39px" />
          <AnimatedSkeletonMultiline
            lines={3}
            spacer={TINY_MARGIN_PX}
            xs={SKELETON_TEXT_HEIGHT_TINY_PX}
          />
        </InfoWrapper>
      </Wrapper>
    );
  }

  return (
    <Wrapper data-testid="sustainableGoal">
      <GoalLogo path={logo} srcset={LOGO_SRCSET} sizes="100vw" />
      <InfoWrapper>
        <GoalImage path={sustainableGoalImg} />
        <BodyText>{description}</BodyText>
      </InfoWrapper>
    </Wrapper>
  );
};

export default SustainableGoal;

const Wrapper = styled('div')`
  margin-top: ${SMALL_MARGIN_PX};
  display: flex;
  flex-direction: column;
  align-items: center;
  ${({ theme }) => theme.breakpoints.up('md')} {
    flex-direction: row;
    max-width: 850px;
  }
`;
const GoalLogo = styled(IKImage)`
  margin-bottom: ${SMALL_MARGIN_PX};
  width: 224px;
  min-width: 224px;
  ${({ theme }) => theme.breakpoints.up('md')} {
    margin-bottom: 0;
    margin-right: ${SMALL_MARGIN_PX};
  }
`;
const InfoWrapper = styled('div')`
  margin-bottom: ${SMALL_MARGIN_PX};
  width: 100%;
  ${({ theme }) => theme.breakpoints.up('md')} {
    margin-bottom: 0;
  }
`;
const GoalImage = styled(IKImage)`
  height: 39px;
  margin-bottom: ${SMALL_MARGIN_PX};
  max-width: 100%;
`;
const LoadingLogo = styled(AnimatedSkeleton)`
  width: 224px;
  min-width: 224px;
  margin-bottom: ${SMALL_MARGIN_PX};
  ${({ theme }) => theme.breakpoints.up('md')} {
    margin-bottom: 0;
    margin-right: ${SMALL_MARGIN_PX};
  }
`;
const LoadingImage = styled(AnimatedSkeleton)`
  width: 340px;
  margin-bottom: ${SMALL_MARGIN_PX};
`;
